import React from 'react';
import {handleImageUrl} from "../../helpers";

const HomeTourItem = ({tour}) => {
    if (!tour) return null;
    return (
        <div className='home-tour-item'>
            <img src={handleImageUrl(tour.thumbnail)} alt={tour.title}/>
            <h3 className="title">{tour.title}</h3>
        </div>
    );
};

export default HomeTourItem;